import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { hooks as commonHooks } from '@sitebuilder/common';
import { actionCreators } from '../../reducers/media';
import {
    ErrorMessage,
    PrimaryButton,
    SideBarAccordion,
    SpinnerIcon,
    SuccessMessage,
} from '../BaseComponents';
import { StateShape as ReduxStateShape } from '../../reducers';

const SaveMediaForm = ({ urlState }: { urlState?: string }) => {
    const dispatch = useDispatch();
    const i18n = commonHooks.useLocalization();
    const [accordionActiveKeys, setAccordionActiveKeys] = useState(['']);
    const [file, setFile] = useState<any>(null);
    const fileInputRef = useRef<any>(null);

    // error message on media save
    const [error, setError] = useState<string>('');

    // success message on media save
    const [success, setSuccess] = useState<string>('');

    const { mediaSaveLoading, mediaSaveSucess, mediaSaveError } = useSelector(
        (state: ReduxStateShape) => ({
            ...state?.media,
        })
    );

    useEffect(() => {
        if (mediaSaveSucess) {
            setSuccess(mediaSaveSucess);
            dispatch(actionCreators.listMedias(urlState || ''));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mediaSaveSucess]);

    useEffect(() => {
        if (mediaSaveError) {
            setError(i18n.t('media_form_save_error'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mediaSaveError]);

    const onClickAccordion = (eventKey: string) => {
        if (accordionActiveKeys.includes(eventKey)) {
            setAccordionActiveKeys(accordionActiveKeys.filter((k) => k !== eventKey));
        } else if (eventKey) {
            setAccordionActiveKeys([eventKey]);
        }
    };

    const handleOnFileUplaod = async (event: any) => {
        if (event?.target?.files?.[0]) setFile(event.target.files[0]);
    };

    const handleOnClick = () => {
        if (fileInputRef?.current) fileInputRef.current.click();
    };

    const handleSubmit = async () => {
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            await dispatch(
                actionCreators.saveNewMedia(
                    urlState ? `${urlState.substring(1)}/${file.name}` : file.name,
                    formData
                )
            );
            setFile(null);
        } else {
            setError(i18n.t('form_missing_file'));
        }
    };

    return (
        <div className="add-new-media-form">
            <hr className="divider" />
            <SideBarAccordion
                toggleTitle={'Upload New Media'}
                eventKey="0"
                defaultActiveKey="0"
                accordionActiveKey={accordionActiveKeys}
                onClickAccordion={onClickAccordion}
            >
                <div className="file-input">
                    <p className="file-name">{file?.name}</p>
                    <button className="file-button" onClick={handleOnClick}>
                        Choose file
                    </button>
                    <input
                        type="file"
                        id="input-file"
                        name="file"
                        ref={fileInputRef}
                        onChange={handleOnFileUplaod}
                        style={{ display: 'none' }}
                    />
                </div>
                <div className="save">
                    {error && <ErrorMessage error={error} />}
                    {success && <SuccessMessage message={success} />}
                    <PrimaryButton
                        id={'save-button'}
                        className={'save-button'}
                        onClick={handleSubmit}
                    >
                        {mediaSaveLoading && <SpinnerIcon />}
                        {i18n.t('upload')}
                    </PrimaryButton>
                </div>
            </SideBarAccordion>
        </div>
    );
};

export default SaveMediaForm;
